/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fetchAPI, URL_API } from 'api';
import { ICuffaUpdateLandCategoryDto } from 'interfaces/cuffa.interface';

const ROTA = '/forms/cuffa';

export const CuffaAPI = {
  async listar(filters: { [key: string]: string }, pagination: any) {
    console.log('filters', filters);
    const params = new URLSearchParams();
    params.append('page', pagination.currentPage.toString());
    params.append('take', pagination.take.toString());
    Object.entries(filters).forEach(([key, value]) => {
      if (value.length > 0) {
        params.append(key, value);
      }
    });
    return await fetchAPI(`${URL_API}${ROTA}?${params.toString()}`, 'GET');
  },

  async getDataByID(uuid: string) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}`, 'GET');
  },

  async getDataByIDProdutos(uuid: string) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/products`, 'GET');
  },


  async createManualCollection(data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/family-data`, 'POST', data);
  },

  async updateFamilyData(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/family-data`, 'PATCH', data);
  },

  async updateLicensesAndInspections(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/licenses-and-inspections`, 'PATCH', data);
  },

  async updateFamilyCertification(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/family-certification`, 'PATCH', data);
  },

  async updateConventionalProduction(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/conventional-production`, 'PATCH', data);
  },

  async updateProcessedProducts(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/processed-products`, 'PATCH', data);
  },

  async updateProductionComercialization(
    collectionUuid: string,
    data: {
      products: Array<{
        product_uuid: string;
        commercialized_value: number;
        commercialized_volume: number;
        measurement_unit: string;
      }>;
      vegetal_license: {
        has_sanitary_license: boolean;
        license_number?: string;
        issuing_agency?: string;
        issue_date?: string;
      };
      animal_inspection: {
        has_inspection_register: boolean;
        inspection_seals?: Array<{
          inspection_seal: string;
          register_number: string;
          issue_date: string;
        }>;
      };
    },
  ) {
    return await fetchAPI(
      `${URL_API}${ROTA}/${collectionUuid}/production-commercialization`,
      'PUT',
      data,
    );
  },

  async getProductionComercialization(collectionUuid: string) {
    return await fetchAPI(
      `${URL_API}${ROTA}/${collectionUuid}/production-commercialization`,
      'GET',
    );
  },

  async getAvailableProcessedProducts() {
    try {
      const response = await fetchAPI(
        `${URL_API}${ROTA}/processed-products/available`,
        'GET'
      );

      return response?.dados;

    } catch (error) {
      console.error("Erro ao obter produtos processados:", error);
      throw error;
    }
  },

  async updateInstitutionalVisit(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/institutional-visits`, 'PATCH', data);
  },

  async updateCommercializationChannels(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/commercialization-channels`, 'PATCH', data);
  },

  async updateCreditAccess(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/credit-access`, 'PATCH', data);
  },

  async updateValueAddedSeals(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/value-added-seals`, 'PATCH', data);
  },

  async updateFamilyIncomeSources(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/family-income-sources`, 'PATCH', data);
  },

  async updateLandCategory(uuid: string, data: ICuffaUpdateLandCategoryDto) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/land-category`, 'PATCH', data);
  },

  async updateIncomeFemaleParticipation(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/income-female-participation`, 'PATCH', data);
  },

  async updateProductionDifficulties(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/production-difficulties`, 'PATCH', data);
  },

  async returnCollectionToMunicipality(
    collectionUuid: string,
    payload: {
      justification: string;
      data_hora: string;
      gerente_estadual: string;
    }
  ) {
    return await fetchAPI(
      `${URL_API}${ROTA}/${collectionUuid}/return-to-municipality`,
      'PUT',
      payload
    );
  },

  async listAllProducts() {
    let page = 1;
    const take = 49;
    let allProducts: any[] = [];
    let hasMore = true;

    while (hasMore) {
      const response = await fetchAPI(
        `${URL_API}${ROTA}/products?page=${page}&take=${take}&sortBy=created_at&orderBy=DESC&withDeleted=false&active_only=true`,
        'GET'
      );

      const data = response.dados?.data || [];
      allProducts = [...allProducts, ...data];

      hasMore = data.length === take;
      page++;
    }

    return allProducts;
  },

  async getProducts(productionTypes?: string[]) {
    let url = `${URL_API}${ROTA}/products`;

    if (productionTypes && productionTypes.length > 0) {
      const params = productionTypes
        .map(type => `productionTypes=${encodeURIComponent(type)}`)
        .join('&');
      url += `?${params}`;
    }

    return await fetchAPI(url, 'GET');

  },

  async updateProducts(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/products-add`, 'PATCH', data);
  },
  async checkExistingCpf(cpf: string) {
    return await fetchAPI(
      `${URL_API}${ROTA}/check-existing?cpf=${cpf}`,
      'GET',
    );
  },

  async sendSignature(
    uuid: string,
    data: {
      signature_uuid: string;
      latitude: number;
      longitude: number;
      coordinate_capture_method: 'AUTOMATIC' | 'MANUAL';
    }
  ) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/signature`, 'PATCH', data);
  },

  async validateAndSend(collectionUuid: string) {
    return await fetchAPI(
      `${URL_API}${ROTA}/${collectionUuid}/validate-and-send-to-state`,
      'PUT'
    );
  },

  async validateAndCreate(collectionUuid: string) {
    return await fetchAPI(
      `${URL_API}${ROTA}/${collectionUuid}/validate-and-create`,
      'PUT'
    );
  }

}
